import { Analytics } from './analytics';

let statLink = $('[stat-block-link] a');

statLink.click((e) => {
    let statLabel = $(e.target).closest('[stat-block-link]').siblings('[stat-block-header]').find('[stat-block-label]').text();
    
    Analytics.sendEvent(`Home page - ${statLabel}`, $(e.target).text(), $(e.target).attr('href'))
});